import { Devices } from "../../../../../src/monitoring/Devices";
import { Link } from "docz";
import * as React from 'react';
export default {
  Devices,
  Link,
  React
};